import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { FieldAttribute, FormGroupControls, SelectorOption } from 'src/app/interfaces/form-and-field.interface';
import { SearchParameters } from 'src/app/interfaces/search.interface';
import { selectSearchOptions } from '../search-fields.metadata';
import { SearchCategories } from '../search.enum';

export interface SearchForm {
  inputField: string;
  search: string;
}

@Component({
  selector: 'app-search-fields',
  templateUrl: './search-fields.component.html',
  styleUrls: ['./search-fields.component.scss'],
})
export class SearchFieldsComponent implements OnInit {
  @Input({ required: true }) public searchOptions: SelectorOption[];

  @Output() private search: EventEmitter<SearchParameters> = new EventEmitter<SearchParameters>();

  public activeOption: SelectorOption;

  public readonly searchForm: FormGroupControls<SearchForm> = new FormGroup({
    inputField: new FormControl(''),
    search: new FormControl(''),
  });

  public attr: FieldAttribute = selectSearchOptions;

  private translateService = inject(TranslateService);

  public ngOnInit(): void {
    this.activeOption = this.searchOptions[0];
    this.initSearchForm();
    this.setSearchOptions();
  }

  public setCategoriesValue(selectorOption: SelectorOption): void {
    this.activeOption = selectorOption;
    this.onSearch();
  }

  public onSearch(): void {
    this.search.emit({
      queryText: this.searchForm.value.inputField.trim(),

      // TODO_3633 figure out how this work
      itemKind: this.activeOption.entity_id as SearchCategories,
    });
  }

  public setSearchOptions(): void {
    this.attr.options = this.searchOptions;
  }

  private initSearchForm(): void {
    this.searchForm.patchValue({
      inputField: '',
      search: this.translateService.instant(this.activeOption.title) as string,
    });
  }
}
